import { LoopPlayer } from '@components/LoopPlayer'
import { NormalizedWrapper } from '@theme'

import { config } from './config'
import { Wrapper, Title, Description } from './styles'

const { title, text, firstVideo, secondVideo } = config

export function VisualDesign() {
  return (
    <Wrapper>
      <NormalizedWrapper>
        <Title>{title}:</Title>
        <LoopPlayer {...firstVideo} />
        <Description>{text}</Description>
        <LoopPlayer {...secondVideo} />
      </NormalizedWrapper>
    </Wrapper>
  )
}
